import React, { createContext, useContext, useEffect, useState } from "react";
import { Theme } from "../../constant/Theme";
import { ThemeContext } from "./ThemeContext";
import { LocalStorageKeys } from "../../types/LocalStorageKeys";

export interface ThemeProviderProps {
  children: React.ReactNode;
}

const GetThemeFromMemory = () => {
  const theme = localStorage.getItem(LocalStorageKeys.THEME);
  if (!theme) return Theme.DARK;
  return theme === Theme.LIGHT ? Theme.LIGHT : Theme.DARK;
};

export const ThemeProvider = ({ children }: ThemeProviderProps) => {
  const [theme, setTheme] = useState<Theme>(GetThemeFromMemory());

  useEffect(() => {
    localStorage.setItem(LocalStorageKeys.THEME, theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme((prevTheme) =>
      prevTheme === Theme.LIGHT ? Theme.DARK : Theme.LIGHT
    );
  };

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};
